import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { disableInspectionService } from '../../api/inspection-service.ts';

export default function useDisableInspectionService(): UseMutationResult<
  Awaited<ReturnType<typeof disableInspectionService>>,
  Error,
  string
> {
  return useMutation({
    mutationFn: (serviceId: string) => disableInspectionService(serviceId),
  });
}
